import React, { useEffect, useState } from "react";
import axios from "axios";

import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import CardGrid from "../../components/card/CardGrid";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Page from '../../components/page/Page'
import { useLanguage } from '../../components/language/LanguageContext'; // Import the custom hook
import FixedLengthText from "../../components/fixed_length";

const imageStyle = {
    height: '250px', // Set the desired height for all images
    width: 'auto',   // Maintain the aspect ratio
    objectFit: 'cover', // Preserve aspect ratio while covering the container
};

const CardItem = ({ article, imgpath, maxLength, children }) => {
    const { language } = useLanguage();

    //console.log("ITEM>>>>>>>>>>>>>>>>>>>>>", item)
    return (
        <Col>
            <Card style={{ border: "1px solid #666464" }}>
                <Card.Img variant="top" src={`${imgpath}${article.media_url}`} style={imageStyle} />
                <Card.Body style={{ backgroundColor: "black", color: "#fff" }}>
                    {language === 'en' ? (
                        <Card.Title>{article.title}</Card.Title>
                    ) : (
                        <Card.Title>{article.title}</Card.Title>
                    )}
                    <div style={{ height: "200px" }}>
                        {language === 'en' ? (
                            <FixedLengthText text={article.summary} maxLength={maxLength} />
                        ) : (
                            <FixedLengthText text={article.summary} maxLength={maxLength} />
                        )}
                    </div>

                    {children}
                </Card.Body>
            </Card>
        </Col>
    );
};

const CardButtons = (props) => {
    return (
        <>
           <Button variant="primary" href={`${props.link}`} >Read</Button>
        </>
    );
}


const CardGridView = (props) => {
    return (
        <CardGrid style={{ display: "flex" }}>
            <CardList></CardList>
        </CardGrid>
    )
}

const NewsList = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("https://stemx365.org/api/v1/news")
            .then((response) => {
                setNews(response.data);
                setLoading(false);
            })
            .catch((error) => console.error("Error fetching news:", error));
    }, []);

    return (
        <div style={{backgroundColor:"black"}}>
            <h1>Space News</h1>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <CardGrid style={{ display: "flex" }}>
                    {console.log("NEWS=====", news)}
                <Row xs={1} md={4} className="g-4">
                    {
                        news ?
                        news.map((article, index) => <CardItem key={index} article={article} imgpath={""} maxLength={300}><CardButtons link={article.link} /></CardItem>) : null
                    }
                </Row>
                </CardGrid>
            )}
        </div>
    );
};

export default NewsList;
